import StorageUtil from "@/utils/storageUtil";
export default {
  user: StorageUtil.readUser(),
  pageType: StorageUtil.readPageType() || "center", // 访问来源
  version: StorageUtil.readVersion(), // app版本号
  sourceType: StorageUtil.readSourceType() || "", // 是否旧版app
  token: StorageUtil.readToken(),
  tokenCookie: StorageUtil.readTokenCookie(),
  customerNumber: StorageUtil.readCustomerNumber(),
  asterisk: StorageUtil.readAsterisk(), // 是否显示总额
  accountNo: StorageUtil.readAccountNo(),
  platform: StorageUtil.readPlatform(), // 平台
  platformName: StorageUtil.readPlatformName(), // 平台名称
  accountInfo: StorageUtil.readAccountInfo(), // 用户信息
  currency: StorageUtil.readCurrency(), // 账号货币
  rechargeData: StorageUtil.readRechargeData(),
  withdrawalData: StorageUtil.readWithdrawalData(),
  gts2CustomerId: StorageUtil.readGts2CustomerId(), // gts2CustomerId
  gts2AccountId: StorageUtil.readGts2AccountId(), // gts2AccountId
  tabIndex: StorageUtil.readTabIndex() || 0, // tab
  timeData: StorageUtil.readTimeData() || new Date(), // tab
  paySwitchStatus: StorageUtil.readPaySwitchStatus(),
  tradeCondition: StorageUtil.readTradeCondition(),
  entrustCondition: StorageUtil.readEntrustCondition(),
  profitAndLossCondition: StorageUtil.readProfitAndLossCondition(),
  creditCondition: StorageUtil.readCreditCondition(),
  stopCondition: StorageUtil.readStopCondition(),
  keepAlive: StorageUtil.readKeepAlive(), // 组件缓存
  tickData: StorageUtil.readTickData(),
};
